// extracted by mini-css-extract-plugin
module.exports = {"mobileDescription":"mobileQuestion_mobileDescription__26bKa","crumb":"mobileQuestion_crumb__10dfy","questionWrapper":"mobileQuestion_questionWrapper__2kFZK"};